module.exports = {
	"grievances": ["grievances_main_category"],
	"personal information": ["main_cat"],
	"work related information": ["main_category"],
	"personal information correction": {
		"civil status": ["civil_status_correction"],
		"full name": ["first_name_correction", "last_name_correction", "maidenmiddle_name"],
		"residence address": ["permanent_address", "current_address"],
		"gender": ["gender_correction"]
	},
	"personal information update": {
		"civil status": ["civil_status_update"],
		"full name": ["first_name_update", "last_name_update", "maidenmiddle_name"],
		"residence address": ["permanent_address", "current_address"],
		"gender": ["gender_update"]
	},
	"separation": ["topics_or_cocnern"],
	"reporting line": ["full_name_of_receiving_managerapprover", "names_of_employees_to_be_transferred", "effective_date"],
	"bank account": ["bank_name", "bank_account_number", "account_type", "valid_id"],
	"allowance": ["type_of_allowance"],
	"bonus/commission": ['type_of_bonus'],
	"hmo entitlement": ["hmo_for_dep_or_own"],


	// "certifications": ["certifications_main_category", "name_of_establishmentrecipient_of_this_requirement", "name_of_dependent_if_applicable"],
	"certifications": ["certifications_main_category",],
	"certificate of coverage": ["name_of_establishmentrecipient_of_this_requirement", "name_of_dependent_if_applicable"],
	"certificate of contribution": ["name_of_establishmentrecipient_of_this_requirement", "name_of_dependent_if_applicable"],
	"hmo": ["certifications_topics_or_concerns", "name_of_establishmentrecipient_of_this_requirement"],
	"philhealth": ["certifications_topics_or_concerns", "name_of_establishmentrecipient_of_this_requirement", "name_of_dependent_if_applicable"],
	"gli": ["name_of_establishmentrecipient_of_this_requirement", "name_of_beneficiary"],

	"benefits claims and processing": ["benefits_claims_amp_processing_sub_category"],
	"medical insurance or hmo": ["name_of_dependent"],
	"statutory loans": ["reason_for_deduction_stoppage_amp_payment_adjustment", "effective_date_start_of_deduction", "effective_date_stop_of_deduction"],
	"sss sickness": ["category_of_filing"],
	"sss maternity": ["category_of_delivery"],

	"pay affecting": ["pay_affecting_category"],

}